module.exports = __webpack_public_path__ + "0af5d249/img/verified-icon.f93bbc14.svg";